module.exports = __webpack_public_path__ + "resources/img/ico_toast.fef4f13341684799dbfa35b7e3d32600.svg";